import HeaderWrapper from '@/components/common/Header/HeaderWrapper';
import { Button } from '@/components/ui/button';
import { showToast } from '@/components/ui/sonner';
import ZoomContext from '@/context/zoom-context';
import { getRoutes } from '@/routes/routePaths';
import { useQuery, useReactiveVar } from '@apollo/client';
import ZoomVideo from '@zoom/videosdk';
import { ArrowLeft, Clock } from 'lucide-react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { GET_SESSION_BY_ID } from '../sessionDetails/GraphQl/queries';
import SessionTimer from './components/session-timer';
import { preSessionVar, sessionVar } from './meetingVar';
import ZoomMtg from './Zoom';

const VideoCall = () => {
  const { id } = useParams();
  const isPreSessionComplete = useReactiveVar(preSessionVar);
  const sessionData = useReactiveVar(sessionVar);
  const navigate = useNavigate();
  const meetingArgs: any = Object.fromEntries(new URLSearchParams(location.search));
  const zmClient = ZoomVideo.createClient();

  useQuery(GET_SESSION_BY_ID, {
    variables: {
      id: id ?? '',
    },
    skip: !id,
    onCompleted: (res) => {
      sessionVar(res?.getSessionById);
    },
    onError: () => {
      showToast({ message: 'Session not found', variant: 'error' });
      navigate(-1);
    },
  });

  useEffect(() => {
    return () => {
      preSessionVar(false);
    };
  }, []);

  return (
    <ZoomContext.Provider value={zmClient}>
      <HeaderWrapper className='bg-black'>
        <div className='flex items-center gap-2'>
          <Button
            onClick={() => navigate(getRoutes.home, { replace: true })}
            id='session-details-back-btn'
            variant='ghost'
            size='icon'
            className='text-white'
          >
            <ArrowLeft className='h-5 w-5' />
          </Button>
          <h1 className='text-lg font-semibold'>#{sessionData?.sessionUniqId}</h1>
        </div>
        {isPreSessionComplete && (
          <div className='flex items-center gap-2'>
            <Clock className='h-5 w-5' />
            <SessionTimer startDateTime={sessionData?.sessionStartTime || ''} />
          </div>
        )}
      </HeaderWrapper>
      <ZoomMtg meetingArgs={meetingArgs} />
    </ZoomContext.Provider>
  );
};

export default VideoCall;
